'use strict';

module.exports = function (next) {
  return function (ctx) {
    var method = ctx.method;

    if (method === 'GET') return next(ctx);

    var values = ctx.values;

    if (!values.password) delete values.password;

    return next(ctx);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/coact/views/middlewares/removeEmptyPassword.js
// module id = 1795
// module chunks = 0